import { useQuery } from 'react-query';

import { getPlanList } from 'api/InteractiveMap/getPlanList';

export const useGetPlanList = (slug: string, options?: { enabled?: boolean }) => {
  const { data, refetch, isLoading, isRefetching } = useQuery('planList', () => getPlanList(slug), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!slug,
    ...options,
  });

  return { data, refetch, isLoading, isRefetching };
};
